import { ColorTreeNoRepBuilder } from "../../General/Tree/colorTree/color-tree-no-rep-builder";
import { TreeNode } from "../../General/Tree/lib/tree-node";

export class ColoredFlagNoRep extends ColorTreeNoRepBuilder {

    protected hideMode: boolean = false;

    leftClickTreeNode(treeNode: TreeNode) {
        if(this.selectedNode == null){
            this.selectedNode = treeNode;
            this.selectedNode.selected();
        }
        else {
            this.selectedNode.resetColor();
            if(this.selectedNode == treeNode){
                this.selectedNode = null;
            }
            else{
                this.selectedNode = treeNode;
                this.selectedNode.selected();
            }
        }
   }



    selectHideMode(mode:boolean) {
        this.hideMode = mode;
    }
 
    getHideMode():boolean{
       return this.hideMode;
    }
}
